import { render, staticRenderFns } from "./EditSPRPage.vue?vue&type=template&id=6b06bc2c&scoped=true&"
import script from "./EditSPRPage.vue?vue&type=script&lang=js&"
export * from "./EditSPRPage.vue?vue&type=script&lang=js&"
import style0 from "./EditSPRPage.vue?vue&type=style&index=0&id=6b06bc2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b06bc2c",
  null
  
)

export default component.exports